<template>
  <div
    class="pitcher-options-select pb-1"
    :class="{
      'is-electron': $isElectron,
    }"
  >
    <span class="bet-slip-select-pitcher-title">{{ $t('BetSlip.ChoosePitcher') }}</span>
    <select
      class="form-control bet-slip-form-control w-100"
      @change="onPitcherChange($event)"
      v-model="line_selection.Pitcher"
    >
      <option v-for="opt in line_selection.PitcherOptions" :key="opt.Id" :value="opt.Id">
        <span>{{
          opt.Description
            .replace(/-R/, $t('Pitcher.RightHand'))
            .replace(/-L/g, $t('Pitcher.LeftHand'))
            .replace(/- R/g, $t('Pitcher.RightHand'))
            .replace(/- L/g, $t('Pitcher.LeftHand'))
            .replace(/Action/g, $t('Pitcher.Action'))
            .replace(/Action/g, $t('Pitcher.Action'))
        }}</span>
      </option>
    </select>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { BDropdown, BDropdownItem } from 'bootstrap-vue';

export default {
  props: ['line_selection'],
  components: {
    BDropdown,
    BDropdownItem,
  },
  computed: {
    getSelectedPitcherFromOptions() {
      const filtered = this.line_selection.PitcherOptions.filter(
        pitcher => pitcher.Id === this.line_selection.Pitcher,
      );
      if (filtered && filtered.length) {
        return filtered[0].Description;
      }

      return this.line_selection.PitcherOptions[0].Description;
    },
  },
  methods: {
    ...mapActions({
      updatePitcherSelection: 'betSlip/updatePitcherSelection',
    }),
    onPitcherChange(event) {
      let opt = this.line_selection.PitcherOptions.find(item => item.Id == event.target.value);
      this.line_selection.Pitcher = opt.Id;
      this.updatePitcherSelection({
        selection_identifier: this.line_selection.OutComeId,
        pitcher: opt,
      });
    },
  },
  mounted() {
    if (this.line_selection.Pitcher) {
      return;
    }
    let opt = this.line_selection.PitcherOptions[0];
    this.line_selection.Pitcher = opt.Id;
    this.updatePitcherSelection({
      selection_identifier: this.line_selection.OutComeId,
      pitcher: opt,
    });
  },
};
</script>

<style lang="scss" scoped>
.pitcher-options-select {
  .bet-slip-select-pitcher-title {
    font-size: 0.875rem;
  }
  .btn-dropdown {
    color: #ffffff;
    box-shadow: none !important;
    border-radius: 0;
    padding: 0px;
    text-align: left;
    width: 100%;

    .dropdown-toggle {
      padding: 0px;
    }

    button {
      background: transparent !important;
      border: none !important;
      box-shadow: none !important;
      padding: 10px;
      width: 100%;
      text-align: left;

      &:after {
        display: none;
      }

      &:hover {
        background: transparent;
      }
    }

    &:after {
      border-top-color: #606381;
    }
  }

  .dropdown-item {
    border-bottom: 1px solid #cccccc;
    cursor: pointer !important;
    color: black;
    padding: 0.45rem 1.5rem;

    &:last-child {
      border-bottom: none;
    }
  }
}
//EPSN-4197 Remove Temporarily pitcher option from betslip
.is-electron {
  display: none !important;
}
</style>
